import * as React from "react";
import type { SVGProps } from "react";
const SvgEraser01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.678 21.341H7.248l-4.52-4.52a1.13 1.13 0 0 1 0-1.593l11.3-11.3a1.13 1.13 0 0 1 1.594 0l5.65 5.65a1.13 1.13 0 0 1 0 1.594l-3.872 3.87m-6.298 6.3 6.298-6.3M9.912 8.046l7.488 6.998"
    />
  </svg>
);
export default SvgEraser01;
